/**
 * Configuración compartida de Chart.js para el Chatbot Comercial.
 * - Registra los componentes que usamos (tree-shaking).
 * - Provee paleta corporativa, formatters y opciones por defecto.
 */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Title,
);

// Paleta corporativa
export const PALETTE = {
  primary: '#9d8272',
  primaryDark: '#8a7162',
  meta: '#E8E8E7',
  metaBorder: '#c8c4be',
  textPrimary: '#2D2D2D',
  textSecondary: '#5A5A5A',
  textMuted: '#888',
  vendido: '#22c55e',
  separado: '#eab308',
  disponible: '#3b82f6',
  bloqueado: '#6b7280',
  preventa: '#a855f7',
};

export const STATUS_COLOR_MAP = {
  V: PALETTE.vendido,
  S: PALETTE.separado,
  D: PALETTE.disponible,
  B: PALETTE.bloqueado,
  P: PALETTE.preventa,
};

// Formatters
export const formatPEN = (n, withCurrency = true) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  const formatted = Number(n).toLocaleString('en-US', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
  return withCurrency ? `S/. ${formatted}` : formatted;
};

export const formatNumber = (n, decimals = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString('en-US', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  });
};

// Compactador para ejes (S/. 1.2M, S/. 250K)
export const formatPENCompact = (n) => {
  if (n === null || n === undefined) return '';
  const v = Number(n);
  if (Math.abs(v) >= 1_000_000) return `S/. ${(v / 1_000_000).toFixed(1)}M`;
  if (Math.abs(v) >= 1_000) return `S/. ${(v / 1_000).toFixed(0)}K`;
  return `S/. ${v.toFixed(0)}`;
};

// Defaults compartidos
export const baseFont = {
  family: "'Inter', system-ui, -apple-system, sans-serif",
  size: 11,
};

export const tooltipDefaults = {
  backgroundColor: 'rgba(45, 45, 45, 0.95)',
  titleColor: '#fff',
  bodyColor: '#fff',
  titleFont: { ...baseFont, size: 12, weight: 'bold' },
  bodyFont: baseFont,
  padding: 10,
  cornerRadius: 8,
  displayColors: true,
  boxPadding: 4,
};
